import Config from './config.web'

const ENVIRONMENT = {
    DEV: "DEV",
    PROD: "PROD",
    STAGE: "STAGE"
}

const _FEATURE_FLAG = {
    ALLOW_ENUM_DROPDOWN :[ENVIRONMENT.DEV, ENVIRONMENT.STAGE, ENVIRONMENT.PROD],
    NEW_HOMESCREEN_URGENT_ISSUES: [ENVIRONMENT.DEV, ENVIRONMENT.STAGE, ENVIRONMENT.PROD],
    USER_SSO_LOGIN: [ENVIRONMENT.DEV, ENVIRONMENT.STAGE, ENVIRONMENT.PROD],
    ALLOW_USER_SIGN_UP: [ENVIRONMENT.DEV, ENVIRONMENT.PROD],
    TEST_ACCOUNT_WARNING_POPUP: [ENVIRONMENT.STAGE],
    VALIDATE_PAYER_RECIPIENT: [ENVIRONMENT.DEV, ENVIRONMENT.STAGE, ENVIRONMENT.PROD],
    SHOW_RECONCILIATION: [ENVIRONMENT.DEV, ENVIRONMENT.STAGE, ENVIRONMENT.PROD],
    SHOW_STATE_PAYROLL: [ENVIRONMENT.DEV, ENVIRONMENT.STAGE, ENVIRONMENT.PROD],
}

export const FEATURE_FLAG = (() => {
    Object.entries(_FEATURE_FLAG).forEach(([key, value]) => _FEATURE_FLAG[key] = value.includes(Config.ENV));
    return _FEATURE_FLAG;
})();
